"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const card_1 = require("../../molecules/card");
const typography_1 = require("../../shared/typography");
exports.default = ({ title, notification, children }) => {
    return ((0, jsx_runtime_1.jsx)(card_1.Card, { header: (0, jsx_runtime_1.jsxs)(Header, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: title }, void 0), notification && (0, jsx_runtime_1.jsx)(typography_1.P, { children: notification }, void 0)] }, void 0), children: (0, jsx_runtime_1.jsx)(Content, { children: children }, void 0) }, void 0));
};
const Header = styled_components_1.default.header `
  display: flex;
  justify-content: space-between;

  h2 {
    margin-bottom: 0;
  }

  p {
    color: ${({ theme }) => theme.colors.greyLighten70};
    font-size: 0.875rem;
    font-style: italic;
    margin-bottom: 0;
  }
`;
const Content = styled_components_1.default.div `
  & > div > div {
    padding-bottom: 0;
    word-break: break-word;
  }

  & > div > div:not(:last-of-type):not(:nth-of-type(3)) > div {
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.silverLighten40};
    padding-bottom: ${({ theme }) => theme.spacings.xs};
  }

  & > div > div:nth-of-type(3) {
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.silverLighten40};
    display: flex;
    padding-bottom: ${({ theme }) => theme.spacings.xs};
  }

  & > div > div > div {
    align-self: flex-start;
  }
`;
//# sourceMappingURL=CurrentSubscription.js.map